/**
 * Playback Store (Zustand)
 * Manages playback state, transport controls, timeline
 */

import { create } from "zustand";

export interface PlaybackStore {
  isPlaying: boolean;
  playheadMs: number;
  loopEnabled: boolean;
  loopStartMs: number;
  loopEndMs: number;
  zoom: number; // pixels per second
  selectedTrackId: string | null;
  horizontalScrollPx: number;

  setPlaying: (playing: boolean) => void;
  setPlayheadMs: (ms: number) => void;
  setLoop: (enabled: boolean, startMs: number, endMs: number) => void;
  setZoom: (zoom: number) => void;
  setSelectedTrack: (trackId: string | null) => void;
  setHorizontalScroll: (px: number) => void;
}

export const usePlaybackStore = create<PlaybackStore>((set) => ({
  isPlaying: false,
  playheadMs: 0,
  loopEnabled: false,
  loopStartMs: 0,
  loopEndMs: 0,
  zoom: 30, // default pixels per second
  selectedTrackId: null,
  horizontalScrollPx: 0,

  setPlaying: (playing) => set({ isPlaying: playing }),
  setPlayheadMs: (ms) => set({ playheadMs: ms }),
  setLoop: (enabled, startMs, endMs) =>
    set({ loopEnabled: enabled, loopStartMs: startMs, loopEndMs: endMs }),
  setZoom: (zoom) => set({ zoom }),
  setSelectedTrack: (trackId) => set({ selectedTrackId: trackId }),
  setHorizontalScroll: (px) => set({ horizontalScrollPx: Math.max(0, px) }),
}));
